module.exports = __webpack_public_path__ + "media/images/pic/brodno/polygon_news_smaller-be85153271463a66730d93651402c42b.svg";